import React from 'react'
import { Col, Row } from 'reactstrap'

const CovidWhyChooseUs = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem1 right-padding6rem1 -md-5 py4'>
            <div className=''>
                <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh- pb-2'>
                    WHY CHOOSE US
                </div>
                <hr className='hr-style my-md-1' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
            </div>

            <div className='pt-4'>
                <Row className=''>
                    <Col md='12' lg='7' className=''>
                        <div className='flex-center pb-3'>
                            <div className='fs-ss-58 text-open fw-700 mtop-neg'>01</div>
                            <div className=''>
                                <div className=''>
                                <div className='ps-3 fs-ss-24 text-montserrat fw-700 text-ss-secondary' style={{ letterSpacing:'0.5px'}}>
                                    Effective and Reliable
                                </div>
                                </div>
                                <div className='ps-3 fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                                    At United Lab Care, you will receive authentic and accurate results from our CLIA-certified partner labs that use the latest technologies.
                                </div>
                            </div>
                        </div>

                        <div className='flex-center pb-3'>
                            <div className='fs-ss-58 text-open fw-700 text-ss-black mtop-neg1 pb-3'>02</div>
                            <div className=''>
                                <div className='ps-3 fs-ss-24 text-montserrat fw-700 text-ss-secondary' style={{ letterSpacing:'0.5px'}}>
                                    Fastest Turnaround Time
                                </div>
                                <div className='ps-3 fs-ss-16 text-montserrat fw-600 text-ss-black pb-3' style={{ letterSpacing:'0.5px'}}>
                                    We focus on delivering results on time so that you can continue your daily routine as soon as possible.
                                </div>
                            </div>
                        </div>

                        <div className='flex-center pb-3'>
                            <div className='fs-ss-58 text-ss-black fw-700 mtop-neg'>03</div>
                            <div className=''>
                                <div className='ps-3 fs-ss-24 text-montserrat fw-700 text-ss-secondary p' style={{ letterSpacing:'0.5px'}}>
                                    Quick and Convenient
                                </div>
                                <div className='ps-3 fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                                    Our professionals perform fast and easy RT-PCR and Rapid Antigen COVID-19 tests because we put our patients first. We make them our priority.
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col md='12' lg='5' className='flex-center pb-5 pt-md-4'>
                        <div className='flex-center'>
                            <img src='covid-testing/Covid-Testing-img2-v1.png' alt='' className='img-w5-2' height="auto" width='%' />  
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
  )
}

export default CovidWhyChooseUs